import { render, staticRenderFns } from "./courtCaseDetailsModal.vue?vue&type=template&id=3bd76f4e&scoped=true"
import script from "./courtCaseDetailsModal.vue?vue&type=script&lang=js"
export * from "./courtCaseDetailsModal.vue?vue&type=script&lang=js"
import style0 from "./courtCaseDetailsModal.vue?vue&type=style&index=0&id=3bd76f4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd76f4e",
  null
  
)

export default component.exports